import React, { useEffect, useState } from "react";
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';

import I18n from "../i18n.js";

import FormFields from "../../base/form/form_fields.js.jsx";

import { UserPaymentMethodModel } from "../../models/users/user_payment_method_model.js";

export const IbanMethod = "iban";

const blockStyles = makeStyles(theme => ({
  root: {
  },
  disclaimer: {
    fontSize: "16px",
    lineHeight: "24px",
    fontWeight: theme.typography.fontWeightLight,
    color: theme.palette.grayText,
    marginBottom: "40px",
    ['@media (max-width: 768px)']: {
      fontSize: "12px",
      lineHeight: "18px",
      marginBottom: "35px",
    },
  },
}));

const PaymentMethodFields = (props) => {

  const classes = blockStyles();
  const { className, onChange, type = IbanMethod } = props;

  const [paymentMethod, setPaymentMethod] = useState(props.paymentMethod);
  const [disclaimer, setDisclaimer] = useState(props.disclaimer || I18n.t("component.payment_method_fields.disclaimer"));
  const [showDisclaimer, setShowDisclaimer] = useState(props.disclaimer);
  const [errorData, setErrorData] = useState(props.errorData);

  useEffect(() => {
    setPaymentMethod(props.paymentMethod);
  }, [props.paymentMethod]);

  useEffect(() => {
    setShowDisclaimer(props.showDisclaimer);
  }, [props.showDisclaimer]);

  useEffect(() => {
    if(props.disclaimer) {
      setDisclaimer(props.disclaimer);
    }
  }, [props.disclaimer]);

  useEffect(() => {
    setErrorData(props.errorData);
  }, [props.errorData]);

  const onItemChange = (changedItem) => {
    const item = {
      ...paymentMethod,
      ...changedItem,
      type: changedItem.type ? changedItem.type : type
    };
    setPaymentMethod(item);

    if(onChange) {
      onChange(item)
    }
  }

  const formFields = UserPaymentMethodModel.formFields({item: paymentMethod, config: {weight: 6}});

  return (
    <div className = { clsx(classes.root, className) } >
      {
        showDisclaimer && disclaimer &&
        <div className = { classes.disclaimer } >
          { disclaimer }
        </div>
      }
      <FormFields formFields = { formFields }
                  item = { paymentMethod }
                  errorData = { errorData }
                  onItemChange = { onItemChange } />
    </div>
  );
}

export default PaymentMethodFields;
